'use client';

import 'sonner/dist/styles.css';
import { Toaster as SonnerToaster } from 'sonner';
import { useDesignTheme } from '@/components/core/providers/DesignThemeProvider';

export function Toaster() {
  const { resolvedMode } = useDesignTheme();

  return (
    <SonnerToaster
      richColors
      position="top-center"
      theme={resolvedMode}
      toastOptions={{
        classNames: {
          toast: 'attune-toast',
        },
      }}
    />
  );
}
